import { Loader } from "../components";
import { useApi } from "../app/ApiContext";
import { LEAGUE_ID, LEAGUE_NAME } from "../app/config";
import { useSettings, useStandings } from "../data";
import { OriginHint, PageHeader } from "../ui";
import "./TableScreen.css";

const Trend = ({ rank, prev }: { rank: number; prev: number }) => {
	const d = prev - rank;
	if (d === 0) {
		return <span className="table-trend faint">·</span>;
	}
	return <span className={d > 0 ? "table-trend good" : "table-trend bad"}>{d > 0 ? `↑${d}` : `↓${-d}`}</span>;
};

export const TableScreen = () => {
	const api = useApi();
	const { loading, error, standings } = useStandings(api, LEAGUE_ID);
	const { myEntryId } = useSettings();

	return (
		<>
			<PageHeader title="League Standings" subtitle={`${LEAGUE_NAME} · head-to-head`} />
			<Loader loading={loading} loadingMessage="Fetching Table" />
			{error && (
				<>
					<p className="error-message">{error}</p>
					<OriginHint />
				</>
			)}
			{!loading && !error && (
				<div className="card table">
					<div className="table-row table-head mono">
						<div>#</div>
						<div>Team</div>
						<div className="num">W·D·L</div>
						<div className="num">PF</div>
						<div className="num">PTS</div>
					</div>
					{standings.map((t) => (
						<div key={t.entry} className={`table-row${t.rank === 4 ? " cutoff" : ""}${t.entry === myEntryId ? " your-row" : ""}`} data-testid={`standing-${t.entry}`}>
							<div className="table-rank mono">
								{t.rank}
								<Trend rank={t.rank} prev={t.last_rank} />
							</div>
							<div className="table-team">
								<div className="table-team-name">{t.entry_name}</div>
								<div className="table-manager">{t.player_name}</div>
							</div>
							<div className="num mono muted">
								{t.matches_won}·{t.matches_drawn}·{t.matches_lost}
							</div>
							<div className="num mono muted">{t.points_for.toLocaleString()}</div>
							<div className="num mono table-points">{t.total}</div>
						</div>
					))}
				</div>
			)}
		</>
	);
};
